const AcademiaAddButton = ({
  children,
  onClick,
  isDisabled,
  title,
}: {
  children: React.ReactNode;
  title?: string;
  onClick?: () => void;
  isDisabled?: boolean;
}) => {
  // rendering custom add button component here
  return (
    <button
      title={title}
      type='button'
      onClick={onClick}
      className='bg-legal-dark-green text-base-white px-4 py-2 rounded-lg text-sm capitalize font-medium hover:opacity-70 duration-300 disabled:opacity-60 disabled:cursor-not-allowed'
      disabled={isDisabled}
    >
      {children}
    </button>
  );
};

export default AcademiaAddButton;
